import React from 'react';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import { canUseMemo } from '@/formbuilder/formbuilder.utilities';
import { useTranslation } from 'react-i18next';
import type { IconType } from '@seeqdev/qomponents';
import { Icon } from '@seeqdev/qomponents';

export interface IconIF extends ValidatingFormComponent<string> {
  component: 'IconFormComponent';
  onIconClick?: (event?: React.MouseEvent<HTMLElement>) => any;
  type?: IconType;
  color?: string;
  id?: string;
  large?: boolean;
  iconClasses?: string;
}

const IconFormComponentUnwrapped: React.FunctionComponent<IconIF> = (props) => {
  const { value, tooltip, onIconClick, testId, extraClassNames, type, color, id, large, iconClasses } = props;
  const { t } = useTranslation();
  const tooltipText = tooltip ? t(tooltip) : undefined;

  return (
    <span className={extraClassNames}>
      <Icon
        type={type}
        color={color}
        id={id}
        tooltip={tooltipText ?? ''}
        large={large}
        icon={value ?? ''}
        onClick={onIconClick}
        testId={testId}
        extraClassNames={iconClasses}
      />
    </span>
  );
};

export const IconFormComponent = React.memo(IconFormComponentUnwrapped, canUseMemo);
